import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import './env'
import { initClarity } from './lib/clarity'
import { initFbPixel, trackPageView } from './lib/fb-pixel'
import { router } from './router'
import './styles/globals.css'

// O pixel base dispara o PageView inicial; como é SPA, cada navegação de rota
// (sem reload) dispara um PageView adicional.
initFbPixel()
initClarity()
let lastTrackedPath = window.location.pathname
router.subscribe((state) => {
  if (state.navigation.state !== 'idle') return
  if (state.location.pathname === lastTrackedPath) return
  lastTrackedPath = state.location.pathname
  trackPageView()
})

const root = document.getElementById('root')
if (!root) throw new Error('Root element #root não encontrado em index.html')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
